import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import Counter from './liveMenuCounter';


@withRouter
@inject('lineStore', 'dictStore', 'appStore')
@observer
class WithVideo extends Component {
  selectItem = () => {
    if (this.props.lineStore.menu.video.games.length > 0) {
      this.props.history.push(`/${this.props.mode}/video`);
    }
  }

  // toggle = () => {
  //   this.props.lineStore.menu[this.props.mode].toggleOpenItem(null, 6);
  // };

  render() {
    const { video, selected } = this.props.lineStore.menu;
    const isSelected = selected.video;

    const { getLang } = this.props.dictStore;

    if (!video.count) return false;

    return (
      <div
        className={`line-left-column-popular-cont${
          isSelected ? ' line-left-column-popular-cont_active' : ''
        }`}
      >
        <div className="line-popular-cont">
          <div className={`favourites-sport-item ${isSelected ? 'favourites-item_active' : ''}`}>
            <div className="line-popular-cont__inner">
              <button
                className="favourites-item-load line-popular-load s-g-popular"
                onClick={this.selectItem}
              >
                <span className="line-sport-menu-item-ico f-s-ico-video" />
                <Counter count={video.count} />
                <div className="favourites-item-load-label">{getLang(`ONLY_WITH_VIDEO`)}</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WithVideo;



// WEBPACK FOOTER //
// ./src/components/liveMenu/withVideo.jsx